


















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import User from "../../../store/entities/user";
import { GetCommunityAll } from "@/api/pdCommunity/index";
import {  GetUserRoles } from '../../../api/dialysisProcess'
import {
  GetDiseaseTypes
} from "@/api/pdReferral";
@Component
export default class EditUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: User = new User();
  communityList: any = [];
  DiseaseTypes: any = [];
  async created() {
    this.getUserRoles();
    let res = await GetCommunityAll();
    this.communityList = res.objects;
    let res1 = await GetDiseaseTypes();
    this.DiseaseTypes = res1;
  }
  get roles() {
    return this.$store.state.user.roles;
  }
  RoleList = []; //角色列表
  get isHeadNurse() {
    return this.RoleList.findIndex((item:any)=> item.roleName=='护士长')!==-1;
  }

  async getUserRoles(){
    let res = await GetUserRoles()
    this.RoleList = res.objects;
  }

  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "user/update",
          data: this.user
        });
        (this.$refs.userForm as any).resetFields();
        this.$emit("save-success");
        this.getUserRoles();
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.user = Util.extend(true, {}, this.$store.state.user.editUser);
    }
  }
  userRule = {
    userName: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("UserName")),
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur"
      }
    ],
    surname: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Surname")),
        trigger: "blur"
      }
    ],
    emailAddress: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Email")),
        trigger: "blur"
      },
      { type: "email" }
    ]
  };
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/user/edit-user.vue